import { PluginFunction } from 'vue';

export type GetVerificationTokenFunc = () => Promise<string>;

const Plugin: PluginFunction<any> = (Vue, options: any) => {
  const Interface: GetVerificationTokenFunc = async function (this: Vue) {
    const element = (this.$refs?.verificationForm ?? null) as HTMLFormElement | null;

    let requestVerificationToken = null;

    // try to retrieve from the form hidden field
    if (element !== null) {
      const input = element.querySelector<HTMLInputElement>('[name="__RequestVerificationToken"]');
      if (input !== null)
        requestVerificationToken = input.value;
    }

    // if unable to retrive from the form hidden field, then fallback to retrieving from endpoint
    if (requestVerificationToken === null) {
      const tokenResponse = await fetch(`/antiforgery/requestToken`, { method: "GET" })

      requestVerificationToken = await tokenResponse.text();
    }

    return requestVerificationToken ?? '';
  }

  Vue.$verificationToken = Interface;
  Vue.prototype.$verificationToken = Interface;
  window.$verificationToken = Interface;
}

export default Plugin;